// extracted by css-extract-rspack-plugin
export default {"splitViewSideConstraint":"splitViewSideConstraint-_nVCHw","replyDetail":"replyDetail-BK_f3F","emptyStateContainer":"emptyStateContainer-eIacDs"};